export const lang = {
    index: {
        mz: '妈祖信仰与泉州天后宫',
        ct: '传统建筑设计与构造教学',
        mn: '闽南侨乡传统修缮训练',
        kh: '考核测试',
        sy: '实验报告',
        exper_header: {
            backButton: '返回'
        }
    },
    mz: {
        score: '当前得分',
        one: {
            zs: '知识学习',
            wt: '问题思考',
            wt_child: {
                title: '思考题',
                js: '【请简述泉州天后宫在妈祖信仰传播中的作用】',
                sub: '提交'
            }
        },
        two: {
            dl: '地理区位',
            cj: '创建历史',
            cj_child: {
                title: "【天后宫的创建】",
                content: '史料记载，泉州天后宫始建于宋庆元二年(1196年)。传说其年，“泉州浯浦海潮庵僧觉全梦神命作宫，乃推里人徐世昌倡建。实当浯江巽水二流之汇，番舶客航聚集之地。时，罗城尚在镇南桥内，而是宫适临浯浦之上。” 当时建的这座妈祖宫规模已经很大，有三殿、山门、两廊、两亭。以宋徽宗宣和四年(1122年)赐额“顺济”，称为顺济宫。“顺济”者，即顺风以济之意。宋元时期，泉州与埃及的亚历山大港齐名，是世界上最大的两个贸易商港之一，与亚洲五十八年国家和地区有贸易往来。同时，泉州的造船业也著称于世，国家出海贸易的船舶“多广州、泉州所造。”宋代，泉州地方长官和市舶司官员，每年春秋两季都举行“祈风”、“祭海”仪式，祈求风浪平青静，航海平安，以鼓励发展对外贸易。 最初祭海在晋江边的真武庙，祈风仪式在南安县的九日山，但到了南宋未年，取而代之的是顺济宫的祭仪。宋元明历朝经常遣官致祭，清康熙五十九年(1720年)钦定春秋两祭，此后，顺济宫官祭便成定例。 　　泉州顺济宫建后十五年，南宋嘉定四年(1211年)郡守邹应龙于笋江下流造石桥，以近顺济宫，因名“顺济桥”。石桥位于顺济宫前，横跨晋江，全长一百五十余丈，宽一点五丈，桥上有石栏杆、塔幢，桥头有威武的石将军、桥堡，横匾上书“雄镇天南”四字，桥中石刻“顺济桥”三字。中外商船泊于岸边江中，首先看见的就是顺济宫和顺济桥这两座雄伟的建筑，“顺济”、“妈祖”之名随之四海传扬。',
                next: '下一页'
            },
            kj: '空间布局',
            ll: '理论测试',
            questions: {
                first: {
                    question: '1.天后宫建筑群中轴线前后顺序是什么？',
                    options: {
                        A: 'A.山门、天后殿、寝殿、梳妆楼',
                        B: 'B.天后殿、山门、寝殿、梳妆楼',
                        C: 'C.山门、寝殿、天后殿、梳妆楼',
                        D: 'D.山门、天后殿、梳妆楼、寝殿'
                    }
                },
                second: {
                    question: '2.下列建筑群，具有与泉州天后宫相似的空间序列的是？',
                    options: {
                        A: 'A.鼓浪屿菽庄花园',
                        B: 'B.漳州文庙',
                        C: 'C.南靖土楼永定楼',
                        D: 'D.泉州泉港区小三房古厝'
                    }
                },
                title: '单选题',
                determine: '确定',
                NextQ: '下一题',
                tipSuccess: '答对了！',
                tipError: '答错了！',
                over: '理论测试已结束，本次测试成绩：',
                NextInteraction: '请点击进入交互训练！'
            }
        }
    },
    ct: {
        one: {
            zs: '知识学习',
            ll: '理论测试',
            jh: '交互训练',
            ll_child: {
                firstQ: {
                    question: '1.下列材料不属于闽南传统建筑材料的是？',
                    options: {
                        A: 'A.烟炙砖',
                        B: 'B.杉木',
                        C: 'C.海蛎壳灰',
                        D: 'D.水泥'
                    }
                },
                secondQ: {
                    question: '2.下列对闽南特有的烟炙砖的说明错误的是？',
                    options: {
                        A: 'A.烟炙砖又称为胭脂砖',
                        B: 'B.烟炙砖是我国古代青砖的一种',
                        C: 'C.烟炙砖是闽南地区特色建筑材料，它是红砖的一种',
                        D: 'D.烟炙砖是在烧制过程中，松枝灰落在砖坯相叠的露空部位，熏出黑色斜纹而形成的'
                    }
                },
                thirdQ: {
                    question: '3.在闽南，“出砖入石”是墙面的一种艺术表现形式，其含义指的是？',
                    options: {
                        A: 'A.砌墙时，砖砌在石头基础的上面',
                        B: 'B.砌墙时，砖作为外墙材料，石材作为内墙材料',
                        C: 'C.砌墙时，砖与大小不一的石材混用，形成极具变化的墙体',
                        D: 'D.墙体中，砖要突出于石材'
                    }
                },
                fourthQ: {
                    question: '4.闽南古代传统建筑中，室内地面不会采用的材料为？',
                    options: {
                        A: 'A.红色斗底砖',
                        B: 'B.木板条',
                        C: 'C.条石',
                        D: 'D.水磨石'
                    }
                }
            },

        },
        two: {
            one: {
                zs: '知识学习',
                ll: '理论测试',
                jh: '交互训练',
                zs_child: {
                    first: {
                        title: '1.中国古代屋顶形式',
                        content: '中国古代建筑的屋顶对建筑立面起着特别重要的作用。他那远远伸出的屋檐、富有弹性的屋檐曲线、由举架形成的稍有反曲的屋面、微微起翘的屋角（仰视屋角，角椽展开犹如鸟翅，故称“翼角”）以及硬山、悬山、歇山、庑殿、攒尖、十字脊、盝顶、重檐等众多屋顶形式的变化，加上灿烂夺目的琉璃瓦，使建筑物产生独特而强烈的视觉效果和艺术感染力。通过对屋顶进行种种组合，又使建筑物的体形和轮廓线变得愈加丰富。而从高空俯视，屋顶效果更好，也就是说中国建筑的“第五立面”是最具魅力的。'
                    },
                    second: {
                        title: '2.天后殿：重檐歇山顶',
                        content: '歇山顶，即歇山式屋顶，宋朝称九脊殿、曹殿或厦两头造，清朝改今称，又名九脊顶。为中国古建筑屋顶样式之一，在规格上仅次于庑殿顶。所谓重檐，是在屋檐下又加了一层屋檐，形成两层屋檐的形式。'
                    },
                    third: {
                        title: '3.东西廊、寝殿：硬山顶',
                        content: '硬山式屋顶是中国传统建筑双坡屋顶形式之一。房屋的两侧山墙同屋面齐平或略高出屋面。 屋面以中间横向正脊为界分前后两面坡，左右两面山墙或与屋面平齐，或高出屋面。高出的山墙称封火山墙，其主要作用是防止火灾发生时，火势顺房蔓延。然而从外形看也颇具风格。'
                    },
                    fourth: {
                        title: '4.屋面构造'
                    }
                },
                ll_child: {
                    first: {
                        question: '1.泉州天后宫寝殿的屋顶形式为？',
                        options: {
                            A: 'A.硬山',
                            B: 'B.悬山',
                            C: 'C.重檐庑殿',
                            D: 'D.歇山'
                        }
                    },
                    second: {
                        question: '2.泉州天后宫天后殿的屋顶形式为？',
                        options: {
                            A: 'A.歇山',
                            B: 'B.重檐歇山',
                            C: 'C.硬山',
                            D: 'D.卷棚'
                        }
                    }
                }
            },
            two: {
                zs: '知识学习',
                ll: '理论测试',
                jh: '交互训练',
                zs_child: {
                    first: {
                        title: '1、闽南结构形式特点',
                        line1: '中国南方浙、闽、粤等地民间一些重要的建筑或一座建筑中主要的构架，常使用一种兼具抬梁式与穿斗式构架特点的混合构架，有人称之为“插梁式构架”。',
                        line2: '插梁式构架的特点是,承重梁的两端插入柱身,与抬梁式构架的承重梁压在柱头上不同，与穿斗式构架的以柱直接承槐、柱间无承重梁、仅有拉接用 的穿榜的形式也不同。具体地讲，即组成屋面的每根橡条下皆有一柱（前后檐柱、金柱、童柱或中柱），每一童柱骑在下面的梁上，而梁端则插入柱身。最下端的大梁两端插入前后金柱柱身，这种结构一般都有前廊步或后廊步,并用多重丁头棋的方式加大出檐,在纵向上，也以插入柱身的联系梁（寿梁或楣、彷）相连。这种构架与抬梁式一样，在文献、工艺及匠师中并没有专门的称渭。',
                        line3: '插梁式构架兼有抬梁与穿斗的特点,它主要以承重梁传递荷载,这是抬梁的原则；而橡条直接压在柱头上，童柱骑在下面的梁上，又有穿斗的特点，但它一般没有通长的穿过柱身的穿杨,其施工方式也与抬梁式构架相似,是现场施工、由下而上、分件组装而成穿斗式构架则是一根排架在地面上组装好，然后整体立起，临时支俵到位，再用纵向穿杨将各福屋架相连插梁式构架的山面往往加设通商的中柱，以增加刚度。',
                        line4: '从构架的稳定性来看,插梁式构架显然优于抬梁式构架,因为它的梁头插入柱身,有多层次的梁柱间插柳，有的还在大梁下另加一道随梁杨以增加稳定性。从承重来看，它的梁跨大于穿斗式，空间开敞，但它的步架又比抬梁式要小。从用料看，它的梁柱粗壮，尤其是大梁，采用近似圆形的断面,是稳定可靠的。'
                    },
                    second: {
                        title: '2、寝殿木构架'
                    },
                    third: {
                        title: '3、梁架构件',
                        type1: {
                            exp: '柱：',
                            exp_title: '对于不同位置上的柱子，闽南工匠有以下几种称呼：',
                            line1: '(1)位于前后檐的檐柱，称为“步柱”、“部柱”、“步口柱”，即通称的檐柱。',
                            line2: '(2)步柱以内的金柱称“青柱”，有“小青柱”、“前青柱”、“后青柱”之分。',
                            line3: '(3)庙宇、祠堂明间的四根内柱，称为“四点金柱”。在四点金柱前后的柱子都称为“付点”或“副点”柱，意为次要的柱子。',
                            line4: '(4)与山墙结合的柱子称为“平柱”又称“附壁柱”。',
                            line5: '(5)支承脊檩的中柱或山柱称“脊柱”，民居之中较多使用。祠堂、庙宇之中，除明间外，其他几缝尤其是山面的梁架多用脊柱，以保持构架的整体稳定。'
                        },
                        type2: {
                            exp: '通梁：',
                            line1: '闽南称梁为“通”、“通梁”。通梁之中，最长、最大、位置最低的一根，称为“大通”，大约即唐宋时期的“通栿”。大通之上的梁，由下而上依次称为“二通”、“三通”。大通一般长达4个或6个步架，插在前后金柱间，这个位置称为“架内”，其上立瓜筒（或叠斗、狮座等）承托二通，二通较大通短两个步架，断面尺寸亦略小些，二通之上再立瓜筒（或叠斗）承托三通，三通中央置瓜筒（或叠斗）承托脊檩。这是前后金柱之间的架内的通梁，架内前后的大方位置的通梁称步通。步通位于檐柱（步柱）与金柱（青柱）之间，内端插入青柱,外端穿过步柱或叠斗承托寮圆，长度通常只有两三个步架。',
                            line2: '通梁之中，大通用料最大，与中脊楹（脊檩）直径相当；二通小于大通约1寸；三通又略小于二通；步通与二通相当。通梁上瓜筒的直径又略大于通梁，以便使瓜脚骑于通梁上。',
                            line3: '通梁的断面有三种：第一种为矩形，用于次间或次要建筑的构架中。第二种作高狭的六角形，即在矩形梁的侧面中间凸出锋线，在漳州地区使用较多。第三种使用最为广泛，通梁侧面呈琴面状，梁身十分饱满，称为“肥通”。第三种梁与宋代以来江南流行的月梁相似，但梁两肩一般无卷杀，梁底中间也不内䫜。其侧面两端入柱处有卷杀，以便过渡成矩形榫头插入柱身或叠斗之中，并且顺势在侧面刻出呈侧卧状的“人”字或“八”字形的曲线，闽南工匠称这种曲线为“鱼尾叉”，鱼尾叉线内的三角形块面又向内凹入。',
                        },
                        type3: {
                            exp: '瓜桶：',
                            line1: '梁上的矮柱，古称侏儒柱。《营造法式》卷五“大木作制度•侏儒柱”说：“侏儒柱，其名有六：一曰棁、二曰侏儒柱、三曰浮柱、四日棳、五日楹、六日蜀柱。“棁、棳皆音拙。棁、浮、棳、蜀疑皆是“侏儒”二字的急读合音。,外端穿过步柱或叠斗承托寮圆，长度通常只有两三个步架。',
                            line2: '北方官式建筑中，承托梁的矮柱有童柱、瓜柱、坨橔等。清式的脊瓜柱柱径较小。仅为三架梁厚的4/5。明代的瓜柱，其直径相当于对应的金柱柱头尺寸。由于直径较大，立于梁上时，两侧宽于梁身厚，于是往往采用骑栿的做法，除瓜柱根部居中做榫外，两侧还作插肩夹皮榫骑于梁背上。',
                            line3: '江南地区的童柱，柱径上细下粗，收杀很大，与柱交接处用骑栿做法。南方地区明清建筑另有一种极为夸张的粗矮童柱。童柱与梁交接处宽于梁背，柱脚伸出包住圆作梁。柱脚包梁的形式表现出不同的地域特征。苏南为一段弧形或海棠叶弧形，比较简单，不作雕刻。浙北及浙东多为出一叶尖锋的鹰嘴形，称“鹰爪”、“鹰嘴”，浙南则为出多叶尖锋的爪形或多瓣的南瓜叶形。',
                            line4: '闽南称这种童柱为“瓜筒”、“木瓜筒”、“筒仔”。瓜筒立在通梁上承托二通、三通及楹仔，断面呈圆形、椭圆形或瓜瓣形。明代以前还使用截面多为瓜瓣形且略呈梭形的蜀柱，如泰宁甘露庵蜃阁【南宋绍兴十六年（1146）】、晋江市青阳庄用宾故居（明代）、漳州市台湾路“两台秉宪、六代承恩”残石坊（明代）、新华东路的“勇壮简易、所向无前”坊（1707）、“闽越雄声、楚滇伟绩”坊（1722）、晋江市衙口靖海侯府（清代初期）等所见。'
                        },
                        type4: {
                            exp: '帅杠：',
                            line1: '角梁是庑殿、歇山、攒尖、廊庑等转角处承托檐椽、飞椽及角脊的关键构件。泉州市开元寺南宋双石塔中，大角梁头形状与昂头相似，与角昂相距较近，且其下不用角神或宝藏神 ，外观几乎与“由昂”相近；子角梁则斜插在大角梁背上，起翅颇多，与江南明清建筑的“嫩戗发戗”做法十分相近。石狮市姑嫂塔(1131—1162)、泉州市清源山弥陀岩石殿(1364)、瑞像岩石殿(1483)等宋元石构仿木建筑中，角梁做法与开元寺双石塔相似，子角梁插于大角梁背上，两者之夹角在130°左右。',
                        },
                        type5: {
                            exp: '灯梁：',
                            line1: '灯梁，也称灯杆，一般安置在正厅明间脊檩（脊圆）与前坡下金檩（下副圆）之间的通梁背上。如果是庙宇、祠堂的五架坐梁式构架，灯梁架于大通的背上；民居则置于一郎或二郎背上，两端或有雕花“灯座”承托；若为“搁檩造”，灯座则插入嵌于墙壁的灯座上。对于房屋的屋架而言，灯梁没有结构上的作用，仅作大厝、祠堂、庙宇悬挂灯笼之用。 ，外观几乎与“由昂”相近；子角梁则斜插在大角梁背上，起翅颇多，与江南明清建筑的“嫩戗发戗”做法十分相近。石狮市姑嫂塔(1131—1162)、泉州市清源山弥陀岩石殿(1364)、瑞像岩石殿(1483)等宋元石构仿木建筑中，角梁做法与开元寺双石塔相似，子角梁插于大角梁背上，两者之夹角在130°左右。',
                            line2: '灯梁的断面呈六角形，闽南工匠以“九五分六角”的方法做出。即在一根直径9份的圆木上，取直径中段5份，上下延伸与圆周相交，得出六角形的上下边，再分别与直径两端相连，连接成六角形。这种分割方法，与《营造法式》卷二“总例”计算正六边形的公式“六棱径八十有七，每面五十，其斜一百”不同。直径9份的圆木的内接六边形，其上下边的边长为5份，得出的是一个形状稍扁的六边形。闽南大木工匠都掌握“九五分六角”这一技术，因为每一幢建筑的大厅都有一根这种断面六角形的灯梁，灯梁之上绘满以红色调为主的包巾彩画，是屋架之中 最为华丽的构件。即使房屋不施彩画.灯梁也必 须绘满彩画。'
                        },
                        type6: {
                            exp: '寿梁：',
                            line1: '寿梁，指步口柱（檐柱）之间的与檩条平行的“阑额”，也写作“受梁”。',
                            line2: '寿梁是檐柱间的额枋，位置显著。福建宋代建筑中的阑额有两种。一种是以福州市华林寺大殿正面外檐为代表的“月梁式”，阑额两肩卷杀，侧面的琴面饱满，入柱处无斜项，底面略有内䫜；另一种是莆田市玄妙观三清殿、泰宁县甘露庵诸殿阁的直梁式，断面呈矩形。',
                            line3: '闽南的寿梁，以第一种月梁式发展而来的最为常见，其断面尺寸较大，一般呈卵蛋形，但顶面与底面削平，侧面的琴面十分饱满，两端入柱处有卷杀，并刻有鱼尾叉，在卷杀等工艺处理上与通梁相似。泉州市开元寺南宋镇国塔与仁寿塔上的阑额，正面作琴面状，两端入柱处作两道鱼尾叉状曲线，但叉内不凹入；在泉州明代文庙大成殿与明伦堂、泉州清源山瑞像岩中，寿梁的鱼尾叉曲线内凹入，清代建筑都做成这种凹入的形式。'
                        },
                        type7: {
                            exp: '束仔、束随：',
                            line1: '位于梁架之上、相邻的两根檩条之间起联系作用的弯月形的弯枋构件，闽南称“束木”、“束仔”、“弯弓”、“水尾”、“弯插”、“虾尾插”。',
                            line2: '束木由宋式的“劄牵”演化而来劄牵是长一椽、起联系作用的梁。',
                        },
                        type8: {
                            exp: '弯枋、连栱：',
                            line1: '闽南古建筑中，联系左右两缝梁架的纵架系统的组件除内额、副檩、顺脊串、顺身串、襻间外，还有以弯枋、连栱等构成的组件，称为“看架”、“排架”。看架用于前后金柱间，是由古代的扶壁栱和纵架发展而来的构架形式。中国南方的宋代建筑如福州市华林寺大殿、浙江宁波保国寺大殿、莆田市玄妙观三清殿等，其扶壁栱都是以令栱承托柱头枋为一组，逐层重叠，直抵榑下。而北方同期建筑则在泥道栱上用多层柱头枋构成井干式的槽，仅在枋上隐刻出栱身。这种单栱素枋交替重叠的做法常见于敦煌壁画中，应是中唐以前的旧法遗存在南方的。',
                            line2: '在民居、宗祠与庙宇中，看架用斗栱及弯枋、素枋等层叠组合，一般的做法是在门眉、寿梁或枋之上，置二、四或六个座斗（没有一、三或五个座斗的做法），斗两侧施以斗抱（斗座），斗之上施左右相连的弯枋，其上再承托一斗三升（三星供）、素枋等再上为圆引，直至圆仔下，以象征二朵、四朵、六朵补间铺作。',
                            line3: '泉州市开元寺天王殿看架的构成是，在左右金柱（闽南称青柱）间施“内额”（闽南称眉），其上施座斗、斗抱两枚，上承弯枋，再上为一斗六升（座斗上承两个三星栱）承素枋，再重叠一层一斗六升与素枋，直抵金檩（青圆）之下。'
                        },
                        type9: {
                            exp: '圆：',
                            line1: '闽南称檩条为圆、圆仔、楹木、楹丁、桁木。',
                            line2: '泉州市开元寺天王殿看架的构成是，在左右金柱（闽南称青柱）间施“内额”（闽南称眉），其上施座斗、斗抱两枚，上承弯枋，再上为一斗六升（座斗上承两个三星栱）承素枋，再重叠一层一斗六升与素枋，直抵金檩（青圆）之下。',
                        },
                        type10: {
                            exp: '桷：',
                            line1: '闽南称椽为桷、桷仔、桷枝。“桷”是椽子的古称。《诗・鲁颂・閟宫》：“松桷有舄，路寝孔硕。”郑笺：“桷，榱也。舄，大貌。路寝，正寝也。”孔疏：“桷之与榱，是椽之别名。《庄二十四年》刻桓宫桷，谓刻其椽也。舄是桷状，故为大貌。”《榖梁传・庄公二十四年》：“刻桓宫桷。礼，天子之桷，斫之砻之。加密石焉。诸侯之桷，斫之砻之。大夫斫之。士斫本。刻桷，非正也。”刻桷，即在桷上刻上装饰。《说文・木部》：“榱，桷也。秦名屋榱也，周渭之椽，齐鲁谓之桷。”唐韩愈《进学解》：“夫大木为杗，细木为桷，欂栌侏儒，椳闑扂楔，各得其宜，施以成室者，匠氏之工也。”唐陆德明《经典释文》曰：“椽，榱也，圆曰椽，方曰桷。”《营造法式》卷二“总释下・椽”引《说文》：“椽方曰桷。”又引唐陆德明《春秋左传音义》曰：“圜曰椽。”可知桷特指方椽，闽南传统建筑中用椽都是方椽，没有用圆椽的。',
                            line2: '闽南用的方椽，并不是断面正方形的椽子。其断面为高宽比1/4左右的扁方形，故乂称“桷仔板”、“板条”，与宋代以来官式建筑中的方椽、圆椽不同。',
                        },
                        type11: {
                            exp: '斗：',
                            line1: '斗是位于栱、昂、枋间的、“斗”状的垫托构件，在闽南称“斗仔”。',
                            line2: '闽南用的方椽，并不是断面正方形的椽子。其断面为高宽比1/斗的种类：',
                            line3_title: '闽南传统建筑中的斗，依外形区分,有以下几种：',
                            line3_1: '（1）方斗，平面方形，又称为四方斗。闽南宋、元、明代建筑中斗皆作此式。',
                            line3_2: '（2）圆斗，平面圆形的斗。有的圆斗，立面不再区分耳、平和欹，整体形状犹如一只碗，又称为碗仔斗、碗公斗。',
                            line3_3: '（3）六角斗，平面六角形，又称为六阁斗。',
                            line3_4: '（4）八角斗，平面八角形，又称为八阁斗。六角斗、八角斗多用于鸡舌栱、藻井之中。',
                            line3_5: '（5）讹角斗，方斗四角卷杀成圆弧形。',
                            line3_6: '（6）海棠斗，将讹角斗的四角刻出窝角曲线，平面如海棠形。闽南明代及清初的石坊如漳州市“尚书、探花”坊（1605）、“三世宰贰、两京扬历”坊（1619）、泉州市施琅神道碑亭（1697）、漳州市“勇壮简易、所向无前”坊（1707）、泉州市“急公尚义”坊（1715）、厦门市“绩光铜柱、思永岘碑”坊（1717）、漳州市“闽越雄声、楚滇伟绩”坊（1722）等，将斗欹四角刻成海棠曲线或抹斜，以与下面的海棠线脚或抹角方柱对应。江浙地区的宋元建筑如江苏省苏州市云岩寺塔、东山县轩辕官正殿、苏州市虎丘云岩寺二山门、浙江省宁波市保国寺大殿等，海棠斗的运用已较为普遍。而在福建的宋元建筑中则未见使用。海棠斗于明代出现后，广泛用于闽南的寺观、祠堂、大厝之中。',
                            line3_7: '（7）梅花斗，平面圆形并分成数瓣，如梅花形。瓜筒上的瓜头斗多用之。',
                            line3_8: '（8）莲斗，平面圆形，做成仰莲形。福建莲斗的实例，以1959年发现但于两年后毁去的泰宁甘露庵的上殿、观音阁、南安阁这三座南宋建筑为最早，莲斗用于柱斗上的栌斗。现存实物则以石狮市金钗山六胜塔［元后至元二年（1336）］为最早，用于每层角柱的栌斗。',
                            line3_9_title_line1: '泉州市开元寺大雄宝殿、泉州府文庙大成殿中都使用莲形栌斗。莲斗表面一般都施彩画，用“化色”渲染出莲瓣的色调和层次。',
                            line3_9_title_line2: '依位置区分，斗有以下诸式：',
                            line3_9_1: '（1）柱头斗，用于柱头上的圆斗、方斗或梅花斗，直径（斜径）与柱子直径相等，经常与柱子连做。',
                            line3_9_2: '（2）瓜头斗，用于瓜筒之上的方斗或圆斗，边长或直径与瓜筒相等，斗底往往有四个卯洞，以便套住瓜筒上的四个凸榫。有的瓜头斗直接从瓜筒上雕出。',
                            line3_9_3: '（3）栱尾斗，栱端的散斗或交互斗。',
                            line3_9_4: '（4）鸡舌斗，用于鸡舌栱之下。',
                            line3_9_5: '（5）寮斗，用于寮圆（挑檐檩）鸡舌栱下的斗，工匠俗写为“辽斗”。',
                            line3_9_6: '（6）连栱尾斗，也称“连栱斗”，用于连栱（鸳鸯交首栱）之上。',
                        },
                        type12: {
                            exp: '栱：',
                            line1: '闽南传统建筑中的栱，按其位置及功能有出跳的“栱仔”、两栱头相连共承一斗的‘’连栱”等；按其外形区分则有关刀栱、葫芦栱、螭虎栱、鸡舌栱、飞天栱、龙头栱、象鼻栱、凤首栱、三星栱、瓜串等，其中以关刀栱、葫芦栱、螭虎栱使用最为广泛；按结构方式区分，有自斗口中出跳的栱与插入柱身的插栱。斜栱在清代晚期才出现，使用极少。',
                            line2: '栱形特征：',
                            line3: '宋代以来的官式建筑中．栱头曲线使用分瓣卷杀的方式进行加工。福建宋元时期的木构建筑和石钩建筑，如福州市华林寺大殿、泉州市开元寺双石塔、清源山弥陀岩、石狮市六胜塔、顺昌宝山寺石殿等，其栱头曲线末分瓣，而是呈现圆滑的弧线；只有莆田市玄妙观三清殿的栱头分成数瓣卷杀，有的且内䫜。',
                            line4: '宋《营造法式》卷四“大木作制度一・栱”规定栱眼做法：“栱两头及中心，各留坐斗处，余并为栱眼，深三份。如用足材栱，则更加一栔，隐出心枓及栱眼。”福建的三座宋代木构建筑——福州市华林寺殿、莆田市玄妙观三清殿、罗源陈太尉官正殿，将栱眼的上棱抹斜，使栱眼呈现两头尖细的葵花仔壳形，抹斜时外浅而内深，造成栱头上翘的视错觉。这种处理未见于同期的江南、岭南建筑中，是福建宋代建筑的地方手法。'
                        },
                    },
                },
                ll_chird: {
                    firstQ: {
                        question: '1.通常情况下，我国传统木构架各构件连接所采用形式为？',
                        option: {
                            A: 'A.榫卯',
                            B: 'B.铰接',
                            C: 'C.绑扎',
                            D: 'D.采用铁钉钉牢'
                        }
                    },
                    secondQ: {
                        question: '2.下列不属于闽南传统木构架地方术语的是？',
                        option: {
                            A: 'A.圆子',
                            B: 'B.瓜筒',
                            C: 'C.大通',
                            D: 'D.垂花门'
                        }
                    }
                }
            },
            three: {
                zs: '知识学习',
                ll: '理论测试',
                jh: '交互训练',
                zs_child: {
                    line1: '闽南传统建筑使用的结构以插梁式构架与承重墙的混合体系为主。',
                    line2: '紧密结合地域特色的建筑材料是闽南传统建筑墙体的重要特征。闽南传统建筑使用当地特色红砖、蛎壳灰、条石等特殊材料，形成了别具一格的建筑风格形式。',
                    line3: '闽南红砖又统称为“烟炙砖”，烟炙砖的制造工艺复杂。首先挑选原材料，用稻田中的泥土做砖坯。烧制红砖的土要比青砖的质量要求高，"土质好的可烧成红色砖瓦;土质差的，会成重灰色;如要烧成红色，土质差的须以好土盖砖面或两个边，以便成品有光面和红色。好的盖面土价为普通土的五倍"。其次是入窑焙烧。 砖坯入窑烧制时侧立斜向堆码，以松枝为主要燃料。松枝灰烬落在砖坯相叠的露空部位， 在朝上的一面熏成黑色斜斑纹。而在码窑时砖坯的排列不尽整齐，故黑斑纹的方向、位置、宽窄不一。但由于上下两砖相叠，两条黑斑纹之间的红纹的宽度一定与砖的厚度相等，而且在砖的6 个面中，只有朝上的这一面才有黑红相间的纹路。烟炙砖色泽艳丽，规格平整，质地极佳，红砖表面有二三道紫黑色纹理。',
                    line4: '蛎壳灰，用蛎壳、蚌壳等烧成的白灰，古称“蜃灰”。《考工记》∶"烧蜃灰垩墙。"是用贝壳烧成的石灰，在春秋战国时就已为人们所认识。',
                    line5: '《天工开物》还详细记述了蝠壳的产生与蜗灰的烧制过程：',
                    line6: '凡海滨石山傍水处，咸浪积压，生出蛎房，闽间中日蚝房。经年久者，长成数丈，阔则数亩，崎岖如石假山形象。蛤之类压入岩中，久则消化作肉团，名曰蛎黄，味极珍美。凡燔蛎灰者，执椎与凿，濡足取来（药铺所货牡蛎，即此碎块），叠煤架火燔成，与前石灰共法。粘砌城墙、桥梁，调和桐油造舟，功皆相同。有误以蚬灰（即蛤粉）为蛎灰者，不格物之故也。',
                    line7: '早在北宋时、蔡襄造泉州洛阳万安桥就用了蛎壳灰。',
                    line8: '用牡蛎壳烧成的壳灰也称为"蛔壳灰"、"大壳灰"。蛎壳灰精致细腻，闽南传统建筑中高超的红砖组砌技术与这种黏结材料是分不开的。',
                    type1: {
                        exp: '石料：',
                        line1: '闽南地区盛产优质花岗岩，常见有青石、白石、黑石等种类。主要用于墙体的基础，对看堵、镜面墙的身堵、裙堵、腰堵、柜台脚，山墙以及石景、门框和窗等。'
                    },
                    type2: {
                        exp: '墙身砌筑的类型：',
                        line1: '闽南沿海一带属于“红砖文化区”，其墙身砖作的类型较为丰富，除了常见勾缝形式的变化，还有砖的排列和组砌形式的差异。',
                        line2: '（1）按构造类型分类',
                        line3: '砖的砌筑方法主要有封砖壁和出砖入石，此外还有土墙、石墙、牡蜗壳墙和杆真墙等采用不同材料制成的墙体。',
                        line4: '外侧砖的砌筑组合方式有多种，包括平砌、斗仔砌和花砖组砌等。',
                        line5: '平砌，即逐层顺砖砌筑，工字缝。在官式中，这种砌法也称“十字缝”。由于没有丁砖与内层拉结，这种方式很容易造成内外分离。',
                        line6: '拼花砖，其组砌形式千变万化，装饰性很强，形成的图案包括卍字、古钱花等，在角牌和中牌也常见用拼花砖组成的文字。'
                    }
                },
                ll_child: {
                    firstQ: {
                        question: '1.下列不属于闽南传统建筑的墙体名称的是？',
                        option: {
                            A: 'A.对看堵',
                            B: 'B.镜面堵',
                            C: 'C.规带',
                            D: 'D.水车堵'
                        }
                    },
                    secondQ: {
                        question: '2.下列不属于闽南传统建筑墙体材料的是？',
                        option: {
                            A: 'A.花岗岩石材',
                            B: 'B.白色瓷砖',
                            C: 'C.烟炙砖',
                            D: 'D.牡蛎壳灰'
                        }
                    }
                }
            },
            four: {
                zs: '知识学习',
                ll: '理论测试',
                jh: '交互训练',
                zs_child: {
                    first: {
                        type1: {
                            exp: '1、材料',
                            line1: '闽南沿海地区传统建筑的院落和室内通常都有砖石铺装。室内地面多用红砖，有方砖、条砖和六角砖等形式，宫观祠庙中还会以条石或者红砖形成各个开间的分隔带；室外的前埕和深井等常用条石或红砖铺地。',
                            line2: '（1）砖',
                            line3: '红砖是闽南沿海地区传统建筑的主要地面材料。在近代洋楼建筑中，也有使用彩色地砖的方式，其色彩素雅，图案精美，但在闽南传统闽南古厝建筑中少见。',
                            line4: '己有诸多学者对闽南红砖的传统烧制技艺进行了研究。目前仍有部分地方还在烧制生产传统红砖，主要用于古建筑的修缮和新建传统式样建筑，虽然砖坯已经采用机器制作，但烧制过程仍为传统工艺，据晋江苏厝砖厂的师傅讲述，窑内温度在1000℃左右，整个制作周期较为漫长，大致需要三到四个月。',
                            line5: '不同的砖料有着不同的用途，如方砖多用于民居和宫观祠庙的室内地面，六角砖常见于部分宫观祠庙中，条砖则主要用于院落和深井的铺装。'
                        },
                        type2: {
                            exp: '方砖：',
                            line1: '方砖以红色为主，看面边长在210—50Omm间，厚度在20—30mm间。其中，“尺二砖”较为常见。厦门传统营造尺为29.40cm，泉州为30.00cm，“尺二”即边长一尺二寸，约360mm。闽南地区只有边长为360mm的方砖有“尺二砖”的专用术语，其他尺寸尚无确切称呼。'
                        },
                        type3: {
                            exp: '条砖：',
                            line1: '用于铺地的条砖看面短边长在95—180mm间，长度在185-280mm间，厚度约为20-30mm，以红砖为主。',
                            line2: '（2）石',
                            line3: '花岗岩条石：',
                            line4: '闽南地区盛产石材，特别是优良的白色花岗岩。花岗岩条石露明面通常由石匠打凿成荔枝面，工匠称之为“两遍齐”，其他面均为自然面，便于和土层较为紧密的结合。截面宽度为270—30Omm，厚度为150mm，条石长度根据现场需要而定。'
                        }
                    },
                    second: {
                        type1: {
                            exp: '2、砖地面',
                            line1: '从砖的排列形式上，可分为以下几种：'
                        }
                    }
                },
                ll_child: {
                    firstQ: {
                        question: '1.闽南传统地面所用材料不包括下列哪种？',
                        options: {
                            A: 'A.红色斗底砖',
                            B: 'B.石灰混合砂浆',
                            C: 'C.花岗岩条石',
                            D: 'D.水刷石'
                        }
                    },
                    secondQ: {
                        question: '2.闽南传统地面施工工序描述错误的是？',
                        options: {
                            A: 'A.施工前要将地砖浸水一段时间',
                            B: 'B.施工时，要先拉线辅助，然后再铺砖',
                            C: 'C.施工时，铺砖的勾缝可以边铺砖边勾缝',
                            D: 'D.勾缝的作用除了美观之外，还可以调节红砖尺寸的误差'
                        }
                    }
                }
            }
        },
    },
    mn: {
        zs: '知识学习',
        ll: '理论测试',
        jh: '交互训练',
        ll_child: {
            dialog: {
                tip: '您尚未完成XXX模块的理论测试（交互训练），是否仍要离开?',
                yes: '是',
                no: '否'
            },
            firstQ: {
                question: '1.下列材料不属于闽南传统建筑材料的是？',
                option: {
                    A: 'A.烟炙砖',
                    B: 'B.杉木',
                    C: 'C.海蛎壳灰',
                    D: 'D.水泥'
                }
            },
            secondQ: {
                question: '2.下列对闽南特有的烟炙砖的说明错误的是？',
                option: {
                    A: 'A.烟炙砖又称为胭脂砖',
                    B: 'B.烟炙砖是我国古代青砖的一种',
                    C: 'C.烟炙砖是闽南地区特色建筑材料，它是红砖的一种',
                    D: 'D.烟炙砖是在烧制过程中，松枝灰落在砖坯相叠的露空部位，熏出黑色斜纹而形成的'
                }
            },
            thirdQ: {
                question: '3.在闽南，“出砖入石”是墙面的一种艺术表现形式，其含义指的是？',
                option: {
                    A: 'A.砌墙时，砖砌在石头基础的上面',
                    B: 'B.砌墙时，砖作为外墙材料，石材作为内墙材料',
                    C: 'C.砌墙时，砖与大小不一的石材混用，形成极具变化的墙体',
                    D: 'D.墙体中，砖要突出于石材'
                }
            },
            fourthQ: {
                question: '4.闽南古代传统建筑中，室内地面不会采用的材料为？',
                option: {
                    A: 'A.红色斗底砖',
                    B: 'B.木板条',
                    C: 'C.条石',
                    D: 'D.水磨石'
                }
            }
        }
    },
    kh: {
        choiceQuestion: {
            start: '开始',
            sub: '提交',
            title: '理论考核',
            firstQ_title: '一.选择题',
            firstQ_title_tip: '（包含单选和多选题，请谨慎答题）',
            type1: {
                question: '1.泉州天后宫正殿天后殿的屋顶形式是什么？',
                options: {
                    A: 'A.庑殿顶',
                    B: 'B.歇山顶',
                    C: 'C.硬山顶',
                    D: 'D.悬山顶'
                }
            },
            type2: {
                question: '2.泉州天后宫始建于什么朝代？',
                options: {
                    A: 'A.汉朝',
                    B: 'B.唐朝',
                    C: 'C.宋朝',
                    D: 'D.明朝'
                }
            },
            type3: {
                question: '3.妈祖信仰的起源地是哪里？',
                options: {
                    A: 'A.莆田',
                    B: 'B.泉州',
                    C: 'C.福州',
                    D: 'D.厦门'
                }
            },
            type4: {
                question: '4.泉州天后宫正殿天后殿的是几开间建筑？',
                options: {
                    A: 'A.三开间',
                    B: 'B.五开间',
                    C: 'C.七开间',
                    D: 'D.九开间'
                }
            },
            type5: {
                question: '5.常见的闽南传统建筑墙体材料为？',
                options: {
                    A: 'A.斗底砖',
                    B: 'B.烟炙砖 ',
                    C: 'C.青砖',
                    D: 'D.混凝土'
                }
            },
            type6: {
                question: '6.闽南传统建筑抹灰材料主要为？',
                options: {
                    A: 'A.壳灰砂浆',
                    B: 'B.水泥砂浆 ',
                    C: 'C.石膏砂浆',
                    D: 'D.以上都是'
                }
            },
            type7: {
                question: '7.闽南传统建筑地面铺装的主要材料为？（多选）',
                options: {
                    A: 'A.斗底砖',
                    B: 'B.水泥砖 ',
                    C: 'C.大理石砖',
                    D: 'D.花岗岩条石'
                }
            },
            type8: {
                question: '8.下列不属于闽南传统建筑屋面材料的是？',
                options: {
                    A: 'A.瓦',
                    B: 'B.望板 ',
                    C: 'C.望砖',
                    D: 'D.斗底砖'
                }
            },
            type9: {
                question: '9.闽南传统建筑两侧厢房的特有地域性名称是？',
                options: {
                    A: 'A.下房',
                    B: 'B.下落 ',
                    C: 'C.榉头',
                    D: 'D.前埕'
                }
            },
            type10: {
                question: '10.泉州天后宫被册封的朝代为？',
                options: {
                    A: 'A.明朝',
                    B: 'B.元朝 ',
                    C: 'C.宋朝',
                    D: 'D.唐朝'
                }
            }
        },
        dialog: {
            title: '考核成绩',
            singleChoice: '选择题',
            multipleChoice: '多选题',
            answer_right: '答题正确',
            anser_wrong: '回答错误',
            score: '考核得分：',
            Company: '分',
            continue: '继续考核',
            result: '理论考核已完成，将进入交互考核环节！',
            start: '立即开始'
        }
    },
    sy: {
        title: '实验报告',
        submit: '提交',
        type1: {
            title: '一.实验目的'
        },
        type2: {
            title: '二.实验过程'
        },
        type3: {
            title: '三.心得体会'
        }
    },
    title: {
        "考核测试": "考核测试",
        "实验报告": "实验报告",
        "天后宫空间布局": "天后宫空间布局",
        "妈祖信仰与泉州天后宫": "妈祖信仰与泉州天后宫",
        "妈祖信仰海外传播": "妈祖信仰海外传播",
        "传统建筑设计与构造教学": "传统建筑设计与构造教学",
        "闽南侨乡传统建筑构造": "闽南侨乡传统建筑构造",
        "各部位做法工序": "各部位做法工序",
        "传统屋面": "传统屋面",
        "传统木架构": "传统木架构",
        "传统地面": "传统地面",
        "传统墙体": "传统墙体",
        "闽南侨乡传统建筑修缮训练": "闽南侨乡传统建筑修缮训练",
        "中华建筑文化海外传播虚拟仿真实验": "中华建筑文化海外传播虚拟仿真实验"
    },
    external: {
        logoTitle: {
            "华侨大学建筑学院": " 华侨大学建筑学院 ",
            "虚拟仿真实验申报管理平台": "虚拟仿真实验申报管理平台"
        },
        login: {
            "登录": "登录",
            "请输入手机号/用户名/邮箱": "请输入手机号/用户名/邮箱",
            "请输入6-11位密码": "请输入6-11位密码",
            "点击图片输入验证码": "点击图片输入验证码",
            "学生": "学生",
            "评审": "评审",
            "立即登录": "立即登录",
            "忘记密码?": "忘记密码?",
            "请输入验证码": "请输入验证码",
            "长度在6到11个字符": "长度在 6 到 11 个字符",
            '登录成功！': '登录成功！'
        },
        register: {
            "注册": "注册",
            "请输入手机号/邮箱": "请输入手机号/邮箱",
            "请输入6-11位密码": "请输入6-11位密码",
            "请再次输入密码": "请再次输入密码",
            "请输入验证码": "请输入验证码",
            "获取验证码": "获取验证码 ",
            "立即注册": "立即注册",
            "请输入密码": "请输入密码",
            "请再次输入密码": "请再次输入密码",
            "两次输入密码不一致!": "两次输入密码不一致!",
            "长度在6到11个字符": "长度在 6 到 11 个字符",
            "请输入验证码": "请输入验证码",
            "请输入验证码": "请输入验证码",
            "注册成功！": "注册成功！",
            "发送成功！": "发送成功！",
        },
        header: {
            "首页": "首页",
            "中心概况": "中心概况",
            "师资队伍": "师资队伍",
            "仿真实验": "仿真实验",
            "建筑作品": "建筑作品",
            "动态新闻": "动态新闻",
            "校企合作": "校企合作",
            "教学成果": "教学成果",
        },
        home: {
            "作品推荐": "作品推荐",
            "更多作品": "更多作品",
            "动态新闻": "动态新闻",
            "更多新闻": "更多新闻",
        },
        zxgk: {
            "中心简介": "中心简介",
            "组织结构": "组织结构",
            "发展历程": "发展历程",
            "规章制度": "规章制度",
            "建设成果": "建设成果",
            "您当前的位置:平台首页>中心概况>": "您当前的位置：平台首页 > 中心概况 >",
            "返回": "返回",
            "正文": "正文",

        },
        szdw: {
            "师资队伍": "师资队伍"
        },
        fzsy: {
            "全部分类": "全部分类",
            "建筑学": "建筑学",
            "暂无数据！": "暂无数据！",
            "城乡规划": "城乡规划",
            "请选择": "请选择",
            "风景园林": "风景园林",
            "建筑遗产保护技术": "建筑遗产保护技术",
            "人居环境科学与技术": "人居环境科学与技术",
            content: {
                header: {
                    "项目首页": "项目首页",
                    "项目团队": "项目团队",
                    "项目描述": "项目描述",
                    "网络要求": "网络要求",
                    "技术架构": "技术架构",
                    "项目特色": "项目特色",
                    "服务计划": "服务计划",
                    "知识产权": "知识产权",
                    "附件材料": "附件材料",
                    "实验指南": "实验指南",
                    "承诺意见": "承诺意见"
                },
                home: {
                    "中华建筑文化海外传播虚拟仿真实验": "中华建筑文化海外传播虚拟仿真实验",
                    "项目简介视频": " 项目简介视频 ",
                    "项目引导视频": " 项目引导视频 ",
                    "所属专业：": " 所属专业：",
                    "对应专业：": "对应专业：",
                    "建筑类": "建筑类",
                    "建筑学": "建筑学",
                    "负责人：": " 负责人：",
                    "陈志宏": "陈志宏",
                    "本项目以闽南传统侨乡建筑的代表泉州天后宫为案例，对其妈祖信仰、建筑空间进行知识点传授，接着利用虚拟仿真技术具有的真实性、模拟性的特点，对营造技艺、修缮复原施工过程进行虚拟还原，让学生在虚拟的环境下进行技艺的学习，亲身体会修缮复原的操作。": "本项目以闽南传统侨乡建筑的代表泉州天后宫为案例，对其妈祖信仰、建筑空间进行知识点传授，接着利用虚拟仿真技术具有的真实性、模拟性的特点，对营造技艺、修缮复原施工过程进行虚拟还原，让学生在虚拟的环境下进行技艺的学习，亲身体会修缮复原的操作。",
                    "开始实验": "开始实验",
                    "项目简介": "项目简介",
                    "引导视频": "引导视频",
                    "问题交流": "问题交流",
                    "常见问题": "常见问题",
                    "请输入问题内容": "请输入问题内容...",
                    "提交问题": "提交问题",
                    "最新问题": "最新问题",
                    "请先登录": "请先登录",
                    "上一页": "上一页",
                    "下一页": "下一页",
                    "请输入关键字，点击搜索按钮进行搜索...": "请输入关键字，点击搜索按钮进行搜索...",
                    "常见问题": "常见问题",
                    "实验评价": "实验评价",
                    "请输入评价内容": "请输入评价内容...",
                    "提交评价": "提交评价",
                    "使用情况": "使用情况",
                    "实验人数": "实验人数",
                    "实验次数": "实验次数",
                    "实验评价": "实验评价",
                    "实验评价：": "实验评价：",
                    "人评分": "人评分",
                    "请先登录！": "请先登录！",
                    "评论内容不能为空！": "评论内容不能为空！",
                    "评论失败": "评论失败",
                    "评论成功": "评论成功"
                },
                xmtd: {
                    "项目描述": "项目描述",
                    "您当前的位置：": "您当前的位置：",
                    "项目首页": "项目首页",
                    ">项目描述": ">项目描述",
                    "正文": "正文 "
                }
            }
        },
        personal: {
            "当前位置：个人中心": "当前位置：个人中心",
            head: {
                "更换头像": "更换头像",
                "上传图片": "上传图片",
                "确认修改": "确认修改"
            },
            nav: {
                "实验成绩": "实验成绩",
                "实验报告": "实验报告",
                "我的作品": "我的作品",
                "已学课程": "已学课程",
                "我的问题": "我的问题",
                "个人信息": "个人信息",
                "账号安全": "账号安全",
            },
            content: {
                one: {
                    "实验成绩": "实验成绩",
                    "返回": "返回",
                    "序号": "序号",
                    "实验名称": "实验名称",
                    "训练时长": "训练时长",
                    "完成时间": "完成时间",
                    "步骤得分": "步骤得分",
                    "报告得分": "报告得分",
                    "操作": "操作",
                    "成绩详情": "成绩详情",
                    "查看步骤": "查看步骤",
                    "排行榜": "排行榜",
                    "虚拟实验：": "虚拟实验：",
                    "耗时：": "耗时：",
                    "总分：": "总分：",
                    "序号": "序号",
                    "排名": "排名",
                    "排名：": "排名：",
                    "查看": "查看",
                    "姓名": "姓名",
                    "耗时": "耗时",
                    "花费时间": "花费时间",
                    "分数": "分数"
                },
                two: {
                    "实验报告": "实验报告",
                    "序号": "序号",
                    "实验名称": "实验名称",
                    "分数": "分数",
                    "批改": "批改",
                    "已批改": "已批改",
                    "未批改": "未批改",
                    "操作": "操作",
                    "返回": "返回",
                    "姓名：": "姓名：",
                    "学号：": "学号：",
                    "查看报告": "查看报告",
                    "实验目的：": "1、实验目的：",
                    "请输入内容": "请输入内容",
                    "实验过程：": "2、实验过程",
                    "心得体会": "3、心得体会",
                    "提交": "提交",
                    "教师评价：": "教师评价：",
                    "教师评分：": "教师评分：",

                },
                three: {
                    "我的作品": "我的作品",
                    "创建": "创建",
                    "查看": "查看",
                    "编辑": "编辑",
                    "删除": "删除",
                    "取消": "取消",
                    "暂无作品": "暂无作品",
                    "删除作品": "删除作品",
                    "删除作品将无法找回，请慎重操作！": "删除作品将无法找回，请慎重操作！",
                    "删除成功！": "删除成功！",
                },
                four: {
                    "已学课程": "已学课程",
                    "序号": "序号",
                    "实验名称": "实验名称",
                    "时长": "时长",
                    "操作": "操作",
                    "继续学习": "继续学习",
                    "重新学习": "重新学习",
                    "暂无数据": "暂无数据"
                },
                five: {
                    "我的问题": "我的问题",
                    "暂无数据！": "暂无数据！",
                },
                six: {
                    "个人信息": "个人信息",
                    "姓名": "姓名",
                    "请输入姓名": "请输入姓名",
                    "性别": "性别",
                    "学号": "学号",
                    "请输入学号": "请输入学号",
                    "班级": "班级",
                    "请输入班级": "请输入班级",
                    "保存": "保存",
                    "退出登录": "退出登录",
                    "长度在2到16个字符": "长度在 2 到 16个字符",
                    "请输入学号": "请输入学号",
                    "请输入班级": "请输入班级",
                    "男": "男",
                    "女": "女",
                    "是否退出登录?": "是否退出登录?",
                    "提示": "提示",
                    "确定": "确定",
                    "取消": "取消"
                },
                seven: {
                    "账号安全": "账号安全",
                    "修改密码": "修改密码",
                    "旧密码": "旧密码",
                    "设置密码": "设置密码",
                    "再次输入密码": "再次输入密码",
                    "保存": "保存",
                    "请输入密码": "请输入密码",
                    "请再次输入密码": "请再次输入密码",
                    "请输入旧密码": "请输入旧密码",
                    "两次输入密码不一致!": "两次输入密码不一致!",
                    "请再次输入密码": "请再次输入密码",
                }
            }
        }
    }
}